import React, { FC } from 'react';
import Divider from '../../../ui/Divider/Divider';
import TextLink, { TextLinkTargetType } from '../../../ui/TextLink/TextLink';
import {
  useAnalyticsPost,
  NarvarClickSubTypes,
  NarvarClickTypes,
  NarvarEventComponents,
  NarvarEventTypes,
} from '../../../../hooks/Analytics';
import { useTranslations } from '../../../../hooks/useTranslations';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './TrackingNumber.module.css';

interface TrackingNumberProps {
  featureName?: string;
  carrier: string;
  carrierLogoUrl: string;
  carrierTrackingLink?: string;
  trackingNumber?: string;
}

const TrackingNumber: FC<TrackingNumberProps> = (props) => {
  const {
    carrier,
    carrierLogoUrl,
    carrierTrackingLink,
    featureName,
    trackingNumber,
  } = props;

  const {
    bodytextDefaultNone: bodyTextStyle,
    linksTrackingDefault: linkStyle,
    linksTrackingHover: linkHoverStyle,
  } = useTheme();

  const { shippingActivityTrackingNumberText } = useTranslations();

  const logEvent = useAnalyticsPost();

  const carrierLogo = (
    <img className={styles.carrierImg} src={carrierLogoUrl} alt={carrier} />
  );

  return (
    <div className={styles.container}>
      <Divider />
      <div className={styles.row}>
        {carrierTrackingLink ? (
          <a
            className={styles.imgWrapper}
            href={carrierTrackingLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {carrierLogo}
          </a>
        ) : (
          <div className={styles.imgWrapper}>{carrierLogo}</div>
        )}
        {trackingNumber && (
          <span className={styles.trackingNumber} style={bodyTextStyle}>
            {shippingActivityTrackingNumberText}
            <br />
            {carrierTrackingLink ? (
              <TextLink
                target={TextLinkTargetType.BLANK}
                linkStyle={{ sDefault: linkStyle, sHover: linkHoverStyle }}
                href={carrierTrackingLink}
                onClick={(): void =>
                  logEvent({
                    clickCategory: NarvarClickSubTypes.EXTERNAL_TRACKING_LINK,
                    clickLinkDestinationUrl: carrierTrackingLink,
                    clickSubType: NarvarClickSubTypes.EXTERNAL_TRACKING_LINK,
                    clickType: NarvarClickTypes.OUTGOING,
                    eventCarrierMoniker: carrier,
                    eventComponent:
                      NarvarEventComponents.NTH_BLOCK_DELIVERY_STATUS,
                    eventFeature:
                      NarvarEventComponents.NTH_BLOCK_DELIVERY_STATUS,
                    eventTrackingNumber: trackingNumber,
                    eventType: NarvarEventTypes.CLICK,
                    feature: featureName,
                    pageComponent:
                      NarvarEventComponents.NTH_BLOCK_DELIVERY_STATUS,
                  })
                }
              >
                {trackingNumber}
              </TextLink>
            ) : (
              trackingNumber
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export default TrackingNumber;
